module.exports = __webpack_public_path__ + "img/star-5.d2ec4ac7.svg";